
// src/connects/notifications-item.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import { pushRoute } from '../actions/route'

export const mapStateToProps = (state)=> {
  return {
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  const { notification } = ownProps
  return {
    togglePriority: ()=> {
      dispatch(actions.updateNotificationStatus(notification.notification_id, {
        priority: notification.priority > 0 ? 0 : 3
      }))
    },

    onClick: ()=> {
      if (!notification.delivered_at)
        dispatch(actions.updateNotificationStatus(
          notification.notification_id,
          { delivered: true, priority: 0 }
        ))

      switch(notification.category) {
      case 'group_profile_updated':
      case 'user_profile_updated':
        dispatch(actions.openRightSidePage('group_members', { group_id: notification.group_id }, true))
        break
      case 'kpi_updated':
        dispatch(actions.openRightSidePage('kpi_chart', { kpi_id: notification.kpi_id, group_id: notification.group_id }, true))
        break
      case 'diary_replied':
        dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids: [notification.diary_id] }, true))
        break
      case 'diary_reported':
      case 'memo_repoted':
      case 'kpi_repoted':
      default:
        if (notification.diary_id)
          dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids: [notification.diary_id] }, true))
        else if (notification.reported_at && ownProps.group_id == 'home') {
          dispatch(actions.closeRightSidePage())
          pushRoute('group_timeline', { group_id: notification.group_id })
        }
        else if (notification.reported_at && ownProps.group_id != 'home') {
          let params = {
            reported_at: notification.reported_at,
            group_id: notification.group_id,
          }
          if (notification.category != 'favorite_reported')
            params.category = notification.category.replace(/(diary|memo|kpi)_.*/, '$1')
          if (notification.parent_user_id)
            params.user_id = notification.parent_user_id
          dispatch(actions.openRightSidePage('pickup_diaries', params, true))
        }
        break
      }
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/notifications-item.js